import { Project } from '../types';

// Import project images directly for now to avoid lazy loading issues
import portfolio1 from '../../assets/images/projects/portfolio-1.png';
import portfolio2 from '../../assets/images/projects/portfolio-2.png';
import portfolio3 from '../../assets/images/projects/portfolio-3.png';
import storyPointer1 from '../../assets/images/projects/story-pointing-1.png';
import storyPointer2 from '../../assets/images/projects/story-pointing-2.png';
import storyPointer3 from '../../assets/images/projects/story-pointing-3.png';
import storyPointer4 from '../../assets/images/projects/story-pointing-4.png';

// Project data with images
export const projects: Project[] = [
    {
        id: 1,
        title: 'Portfolio Website',
        description: 'My personal portfolio website built with React.js, TypeScript, and Material UI. It showcases my projects, skills, and experiences.',
        images: [portfolio1, portfolio2, portfolio3],
        technologies: ['React.js', 'TypeScript', 'Material UI', 'AWS'],
        features: [
            'Responsive design with Material UI components',
            'TypeScript implementation for type safety and maintainability',
            'Showcase my projects, skills, and experiences'
        ],
        private: false,
        liveUrl: 'https://tejasrana.in',
        githubUrl: 'https://github.com/tony3898',
        status: 'Completed',
        duration: 'Aug 2019'
    },
    {
        id: 2,
        title: 'Story Pointer',
        description: 'A web application that allows users to story point the Jira tickets for their sprints. It is built with React.js, Firebase, and Tailwind CSS.',
        images: [storyPointer1, storyPointer2, storyPointer3, storyPointer4],
        private: true,
        technologies: ['React.js', 'TypeScript', 'Firebase', 'Tailwind CSS', 'AWS'],
        features: [
            'Manage Users with Firebase Authentication',
            'Manage Sprint Team Rooms',
            'Manage Tickets',
            'Use Uncertainty, Effort and Complexity to estimate tickets',
            'Estimate Tickets with Story Points',
            'Real-time collaboration for sprint planning'
        ],
        liveUrl: 'https://sp.tejasrana.in',
        githubUrl: 'https://github.com/tony3898/story-pointer',
        status: 'Completed',
        duration: 'Jul 2025'
    }
];

// Lazy load project images function (for future use)
export const getProjectImages = async (projectId: number): Promise<string[]> => {
    switch (projectId) {
        case 1:
            return [portfolio1, portfolio2, portfolio3];
        case 2:
            return [storyPointer1, storyPointer2, storyPointer3, storyPointer4];
        default:
            return [];
    }
};
